import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

enum FORMAT {
  LOWERCASE = 'LOWERCASE',
  UPPERCASE = 'UPPERCASE',
  CAPITALIZE = 'CAPITALIZE'
};

@Pipe({ name: 'noUnderscore' })
export class NoUnderscorePipe implements PipeTransform {
  constructor(private translate: TranslateService) { }

  transform(value: string, format: FORMAT): string {
    const replaced = value.replace('_', ' ');

    switch(format){
      case FORMAT.UPPERCASE: {
        return `${replaced.toUpperCase()}`
        break;
      }
      case FORMAT.LOWERCASE: {
        return `${replaced.toLowerCase()}`
        break;
      }
      case FORMAT.CAPITALIZE: {
        return `${replaced[0].toUpperCase() + replaced.substring(1).toLowerCase()}`
        break;
      }
      default: {
        return replaced;
      }
    }
  }
}
